
<div
  :class="
    classes(
      n(),
    )
  "
  role="group"
>
  <!-- 使用 options 渲染 -->
  <template v-if="options && options.length">
    <Checkbox
      v-for="(option, index) in normalizedOptions"
      :key="index"
      :checkbox-value="getOptionValue(option)"
      :label="getOptionLabel(option)"
      :desc="getOptionDesc(option)"
      :disabled="disabled || getOptionDisabled(option)"
    />
  </template>
  <!-- 使用 slot 渲染 -->
  <template v-else>
    <slot />
  </template>
</div>
